// Class: starling.assets.AssetPostProcessor

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function js__$Boot_HaxeError() {return require("./../../js/_Boot/HaxeError");}
function openfl_errors_ArgumentError() {return $import(require("openfl/errors/ArgumentError"));}

// Constructor

var AssetPostProcessor = function(callback,priority) {
	if(callback == null) {
		throw new (js__$Boot_HaxeError().default)(new (openfl_errors_ArgumentError().default)("callback must be a function " + "accepting one 'AssetStore' parameter"));
	}
	this._callback = callback;
	this._priority = priority;
}

// Meta

AssetPostProcessor.__name__ = ["starling","assets","AssetPostProcessor"];
AssetPostProcessor.prototype = {
	execute: function(store) {
		this._callback(store);
	},
	get_priority: function() {
		return this._priority;
	}
};
AssetPostProcessor.prototype.__class__ = AssetPostProcessor.prototype.constructor = $hxClasses["starling.assets.AssetPostProcessor"] = AssetPostProcessor;

// Init

Object.defineProperties(AssetPostProcessor.prototype,{ "priority" : { get : function () { return this.get_priority (); }}});

// Statics




// Export

exports.default = AssetPostProcessor;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/assets/AssetPostProcessor.js
// module id = 290
// module chunks = 0